import styled from 'styled-components'
import { Breadcrumb } from 'antd'
import { colors } from 'Common/constants'
export const BreadcrumbItem = styled(Breadcrumb.Item)`
  color: ${colors.main};
  padding: 16px 0;
`
